module.exports = __webpack_public_path__ + "static/media/tender-min.19cbf92e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/tender-min.png
// module id = 245
// module chunks = 0